import { ErrorTypeEnum } from '@sola/schema/dotcom/shared/errors.js';

import { UserError } from '../errors-user';

export const userErrorBadParam = (badParam: string) =>
  new UserError({
    type: ErrorTypeEnum.BadParameter,
    data: {
      badParam,
    },
    statusCode: 400,
  });
